import ColisScanner from "@/components/colis/ColisScanner";
import PickUpConfirmationDialog from "@/components/dialogs/PickUpConfirmationDialog";
import ActionButton from "@/components/loader-button/ActionButton";
import { NavigationRoutes } from "@/components/navigation/constants";
import ReturnHeader from "@/components/return/ReturnHeader";
import { Toaster } from "@/components/ui/toaster";
import { DialogType } from "@/enums/dialogs";
import { toast } from "@/hooks/use-toast";
import { Colis, ReturnToCreate } from "@/interfaces/Return";
import { confirmerRamassage } from "@/services/return-delivery-confirmation.service";
import { closeDialog, openDialog } from "@/store/reducers/dialogReducer";
import { RootState } from "@/store/store";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const ReturnPickUpValidationPage: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [scannedColis, setScannedColis] = React.useState<Colis[]>([]);
  const [isLoading, setIsloading] = React.useState(false);
  const return_ = useSelector((state: RootState) => state.return.return);
  const isOpen = useSelector((state: RootState) => state.dialog.isOpen);

  const validationButtonDisabled = () => {
    return scannedColis.length !== return_.colis?.length;
  };

  const handleValidation = async () => {
    if (isOpen === false) {
      dispatch(openDialog(DialogType.PICKUP_CONFIRMATION_DIALOG));
      return;
    }
    const request = {
      numTournee: return_.numTournee.toString() || "",
      isSellerVIP: return_.isSellerVIP,
      sellerId: return_.sellerId,
      entityId: return_.entityId,
    } as ReturnToCreate;
    try {
      dispatch(closeDialog());
      setIsloading(true);
      const response = await confirmerRamassage(request);
      if (response.status === 200 && response.data.success === true) {
        toast({
          title: "Ramassage validée",
          variant: "success",
        });
        navigate(NavigationRoutes.DASHBOARD, { replace: true });
      } else {
        toast({
          title: "Erreur lors de la validation",
          variant: "destructive",
        });
      }
    } catch (error) {
      toast({
        title: "Erreur lors de la validation",
        variant: "destructive",
      });
    } finally {
      setIsloading(false);
    }
  };

  return (
    <div className="flex flex-col h-full gap-4">
      <ReturnHeader return_={return_} />
      <ColisScanner
        scannedColis={scannedColis}
        setScannedColis={setScannedColis}
        colis={return_.colis}
      />
      <div className="px-4 flex space-x-4 flex-row">
        <ActionButton
          loading={isLoading}
          disabled={validationButtonDisabled() || isLoading}
          handleClick={handleValidation}
          label="Valider le ramassage"
        />
      </div>
      <Toaster />
      <PickUpConfirmationDialog handleValidate_={handleValidation} />
    </div>
  );
};

export default ReturnPickUpValidationPage;
